export const maxRecentClients = 3;

const normalizeKeyPart = (value) => String(value ?? "").trim().toLowerCase();

export const getRecentClientKey = (client) => {
    if (client.medicaidid) {
        return `client:${normalizeKeyPart(client.medicaidid)}`;
    }

    if (client.applicationid) {
        return `application:${normalizeKeyPart(client.applicationid)}`;
    }

    return client.targetUrl ? `target:${normalizeKeyPart(client.targetUrl)}` : "";
};

export const normalizeRecentClients = (clients) => {
    const uniqueClients = [];
    const seenKeys = new Set();

    for (const client of Array.isArray(clients) ? clients : []) {
        const key = getRecentClientKey(client ?? {}) || client?.key;

        if (!key || seenKeys.has(key)) {
            continue;
        }

        seenKeys.add(key);
        uniqueClients.push({
            ...client,
            key
        });

        if (uniqueClients.length === maxRecentClients) {
            break;
        }
    }

    return uniqueClients;
};
